import { render, staticRenderFns } from "./brokers-directory.vue?vue&type=template&id=60325ffd"
import script from "./brokers-directory.vue?vue&type=script&lang=js"
export * from "./brokers-directory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./brokers-directory.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,BrokersList: require('/vercel/path0/components/datablocks/BrokersList.vue').default,CtaIvestorFullWidth: require('/vercel/path0/components/blocks/CtaIvestorFullWidth.vue').default})
